import { render, staticRenderFns } from "./GirlsUnique.vue?vue&type=template&id=2a2aef1e&"
import script from "./GirlsUnique.vue?vue&type=script&lang=js&"
export * from "./GirlsUnique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports